/*
 * flashmeeting-fe
 *
 * Author: Andgel BRISSAUD
 * Copyright (c) 2024 Prodeo - All Rights Reserved
 */

/* ===== External Libraries ===== */
import { AXIOS, CallbackErrorAxios, CallbackWarningAxios, CommonGlobalService } from '@umanforge/common';
import { AxiosResponse, AxiosError } from 'axios';
import { Dispatch } from '@reduxjs/toolkit';

/* ===== API Configuration ===== */
import { API } from 'constants/api.constant';

/* ===== Types and Interfaces ===== */
import { GlobalSetting } from 'interfaces/globalSetting.interface';

/* ===== Services ===== */
import { GlobalService } from './global.service';

export class GlobalSettingsService {
  /* ===== Fetch global settings ===== */
  static getGlobalSettings(
    clientId: string,
    token: string | null, dispatch: Dispatch,
    onError?: CallbackErrorAxios, onWarning?: CallbackWarningAxios
  ): Promise<GlobalSetting[]> {
    return new Promise( async resolve => {
      AXIOS.get( `${API.GLOBAL_SETTINGS}/clientId/${clientId}`, await CommonGlobalService.getHeaderRequest( token ) )
        .then( ( response: AxiosResponse<GlobalSetting[]> ) => {
          CommonGlobalService.saveRequestToken( response, dispatch );
          if ( response.status === 202 ) {
            GlobalService.onAxiosWarning( response, onWarning );
          }
          resolve( response.data );
        } )
        .catch( ( err: AxiosError ) => {
          GlobalService.onAxiosError( err, dispatch, onError );
        } );
    } );
  }

  /* ===== Update global setting by ID ===== */
  static updateGlobalSettingById(
    id: string, keyframe: string, value: string | number, type: string, clientId: string,
    token: string | null, dispatch: Dispatch,
    onError?: CallbackErrorAxios, onWarning?: CallbackWarningAxios
  ): Promise<void> {
    return new Promise( async resolve => {
      const payload = { keyframe, value, type, clientId };

      AXIOS.put( `${API.GLOBAL_SETTINGS}/id/${id}`, payload, await CommonGlobalService.getHeaderRequest( token ) )
        .then( ( response: AxiosResponse ) => {
          CommonGlobalService.saveRequestToken( response, dispatch );
          if ( response.status === 202 ) {
            GlobalService.onAxiosWarning( response, onWarning );
          }
          resolve();
        } )
        .catch( ( err: AxiosError ) => {
          GlobalService.onAxiosError( err, dispatch, onError );
        } );
    } );
  }

}